import get from 'lodash.get';

export const selectType = (state, importType) => {
  return get(state, importType, {});
};
